import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Nav } from "reactstrap";
import { auth } from "../../firebase"; // Upewnij się, że ścieżka jest poprawna

// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

// import logo from "./logo.svg"; // Jeśli nie używasz logo, możesz usunąć lub zakomentować

var ps;

function Sidebar(props) {
  const location = useLocation();
  const [accountType, setAccountType] = useState(null); // Lepiej zainicjować null/undefined
  const sidebar = React.useRef();

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };

  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1 && ps) { // Sprawdź czy ps istnieje
        ps.destroy();
      }
    };
  }, []); // Pusta tablica zależności, aby uruchomić tylko raz

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => { // Zapisz funkcję unsubscribe
      if (user && user.displayName) { // Sprawdź czy user i displayName istnieją
        // Uproszczona logika ustawiania typu konta
        const validTypes = ['superadmin', 'porter', 'manager', 'shunter'];
        if (validTypes.includes(user.displayName)) {
            setAccountType(user.displayName);
        } else {
            setAccountType(null); // lub jakiś domyślny typ/obsługa błędu
        }
      } else {
        setAccountType(null); // Użytkownik wylogowany
      }
    });

    return () => unsubscribe(); // Wywołaj unsubscribe przy odmontowywaniu komponentu
  }, []);

  return (
    <div
      className="sidebar"
      data-color={props.bgColor}
      data-active-color={props.activeColor}
    >
      {/* Możesz tu dodać logo, jeśli chcesz */}
      {/* <div className="logo">
        <a
          href="https://www.creative-tim.com?ref=pdr-sidebar"
          className="simple-text logo-mini"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="logo-img">
            <img src={logo} alt="react-logo" />
          </div>
        </a>
        <a
          href="https://www.creative-tim.com?ref=pdr-sidebar"
          className="simple-text logo-normal"
          target="_blank"
          rel="noopener noreferrer"
        >
          Creative Tim
        </a>
      </div> */}
      <div className="sidebar-wrapper" ref={sidebar}>
        <Nav>
          {props.routes.map((prop, key) => {
             // Twoja istniejąca logika warunkowa renderowania tras
             // Upewnij się, że `prop.layout` jest zdefiniowany, domyślnie może to być np. "/admin"
             const routePath = (prop.layout || '') + prop.path;

             if (accountType) {
                if (accountType === 'superadmin') {
                  if (prop.name !== 'EDIT PROFILE' && !prop.name.startsWith('PARKING #')) {
                    return (
                      <li className={activeRoute(prop.path) + (prop.pro ? " active-pro" : "")} key={key}>
                        <NavLink to={routePath} className="nav-NavLink">
                          {/* Możesz dodać ikonę, jeśli trasa ją ma: <i className={prop.icon} /> */}
                          <p>{prop.name}</p>
                        </NavLink>
                      </li>
                    );
                  }
                } else if (accountType === 'manager') {
                    if (prop.name !== 'EDIT PROFILE' && prop.name !== 'ACCOUNTS' && prop.name !== 'HOLIDAYS' && prop.name !== 'BACKUP AND CONDITION' && !prop.name.startsWith('PARKING #')) {
                      return (
                        <li className={activeRoute(prop.path) + (prop.pro ? " active-pro" : "")} key={key}>
                          <NavLink to={routePath} className="nav-NavLink">
                            <p>{prop.name}</p>
                          </NavLink>
                        </li>
                      );
                    }
                } else if (accountType === 'shunter') {
                    if (prop.name !== 'EDIT PROFILE' && prop.name !== 'PRE-ALERTS' && prop.name !== 'CALENDAR' && prop.name !== 'ACCOUNTS' && prop.name !== 'HOLIDAYS' && prop.name !== 'BACKUP AND CONDITION' && prop.name !== 'ARRIVALS AND DEPARTURES' && !prop.name.startsWith('PARKING #')) {
                         return (
                           <li className={activeRoute(prop.path) + (prop.pro ? " active-pro" : "")} key={key}>
                             <NavLink to={routePath} className="nav-NavLink">
                               <p>{prop.name}</p>
                             </NavLink>
                           </li>
                         );
                    }
                } else if (accountType === 'porter') {
                    if (prop.name !== 'EDIT PROFILE' && prop.name !== 'PRE-ALERTS' && prop.name !== 'CALENDAR' && prop.name !== 'ACCOUNTS' && prop.name !== 'HOLIDAYS' && prop.name !== 'BACKUP AND CONDITION' && prop.name !== 'ARRIVALS AND DEPARTURES' && !prop.name.startsWith('PARKING #') && prop.name !== 'CONTAINERS PARKING') {
                         return (
                           <li className={activeRoute(prop.path) + (prop.pro ? " active-pro" : "")} key={key}>
                             <NavLink to={routePath} className="nav-NavLink">
                               <p>{prop.name}</p>
                             </NavLink>
                           </li>
                         );
                    }
                }
             }
             return null; // Zwróć null, jeśli żadne warunki nie są spełnione dla danej trasy
          })}

          {/* === DODANY LINK DO POWER BI START === */}
          {/* Ten link pojawi się dla wszystkich zalogowanych użytkowników */}
          {/* Jeśli chcesz go pokazać tylko dla konkretnych ról, */}
          {/* dodaj warunek if(accountType === 'manager' || accountType === 'superadmin') itp. */}
          {accountType && ( // Pokaż tylko jeśli użytkownik jest zalogowany (ma typ konta)
            <li key="powerbi-link"> {/* Unikalny klucz dla elementu listy */}
              <a
                href="https://app.powerbi.com/"
                target="_blank" // Otwiera w nowej karcie
                rel="noopener noreferrer" // Względy bezpieczeństwa
                className="nav-NavLink" // Użyj tej samej klasy co NavLink dla spójności stylu
                style={{ textDecoration: 'none' }} // Opcjonalnie, jeśli klasa NavLink nie usuwa podkreślenia z <a>
              >
                {/* Możesz dodać ikonę, np. z Font Awesome lub inną bibliotekę ikon */}
                {/* <i className="ikona-powerbi" /> */}
                <p>Reports from Excels</p> {/* Użyj <p> tak jak w NavLink */}
              </a>
            </li>
          )}
          {/* === DODANY LINK DO POWER BI KONIEC === */}

        </Nav>
      </div>
    </div>
  );
}

export default Sidebar;